import _ from 'lodash';
import Link from 'ui/Link';
import reporter from 'privates/reporter';
import {generateError} from 'privates/validations/errors';

function isEmptyString(value) {
    return value === '';
}

function convertLinkToModelFormatAndReportIfError(link, target, functionName, index) {
    const convertedLink = convertLinkToObjectAndReportIfError(link, target, functionName, index);
    if (isEmptyString(convertedLink)) {
        return convertedLink;
    }

    if (_.isError(convertedLink) || _.isNil(convertedLink)) {
        return;
    }

    return convertedLink.getData();
}

function convertLinkToUrlAndReportIfError(link, target, functionName, index) {
    const convertedLink = convertLinkToObjectAndReportIfError(link, target, functionName, index);
    if (isEmptyString(convertedLink)) {
        return convertedLink;
    }

    if (_.isError(convertedLink) || _.isNil(convertedLink)) {
        return;
    }

    return convertedLink.getValue();
}

function convertLinkToObjectAndReportIfError(link, target, functionName, index) {
    if (!link) {
        return link;
    }

    try {
        return new Link(link, target);
    } catch (e) {
        const ERROR_TYPE = {
            UnsupportedLinkTypeError: 'error_unsupported_link',
            UnsupportedTargetValueError: 'error_unsupported_target'
        };

        const error = !_.isNil(index) ? _.get(generateError, `${ERROR_TYPE[e.name]}_with_index`) : _.get(generateError, ERROR_TYPE[e.name]);
        reporter.reportSdkError(error({
            functionName,
            index,
            wrongValue: link,
            supportedTargets: e.supportedTargets
        }));
        return e;
    }
}

export default {
    convertLinkToModelFormatAndReportIfError,
    convertLinkToUrlAndReportIfError
};



// WEBPACK FOOTER //
// ./js/modules/privates/utils/linkGenerator.es6